import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import FileList from './FileList';
import CustomPagination from '../../CustomPagination';
import CommonTable from '../../CommonTable/CommonTable';
import Loader from '../../Loader/Loader';

import DocumentManagement from './DocumentManagementQuery.graphql';
import showAllDocumentQuery from './showAllDocumentQueryFile.graphql';
import messages from '../../../locale/messages';
import { sendEmail } from '../../../core/email/sendEmail';
import { debounce } from '../../../helpers/debounce';
import showToaster from '../../../helpers/showToaster';
import { withMutation, withQuery } from '../../../hoc/withGraphql';
import { decode } from '../../../helpers/queryEncryption';
import { censorEmail } from '../../../helpers/secureEmail';
import { demoRestrictionEncode } from '../../../helpers/DemoRestriction/demoRestriction';

import s from './DocumentVerification.css';
import bt from '../../../components/commonStyle.css';

class DocumentVerification extends React.Component {

  static propTypes = {
    data: PropTypes.array,
    title: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      isRestrict: false
    };
    this.handleSearchChange = debounce(this.handleSearchChange.bind(this));
  }

  async componentDidMount() {
    const { demoRestrictionEncode } = this.props;
    const isRestrict = await demoRestrictionEncode();
    this.setState({ isRestrict });
  }

  paginationData = (currentPage) => {
    const { showAllDocument: { refetch }, setStateVariable } = this.props;
    let variables = { currentPage };
    this.setState({ currentPage });
    setStateVariable(variables);
    refetch(variables);
  }

  handleSearchChange(searchList) {
    const { showAllDocument: { refetch }, setStateVariable } = this.props;
    let variables = {
      currentPage: 1,
      searchList,
    };
    setStateVariable(variables);
    refetch(variables);
  }

  handleUpdate = async (id, status, item) => {
    const { mutate, currentPage } = this.props;
    const { showAllDocument: { refetch }, setStateVariable } = this.props;
    let variables = { currentPage };
    const { data } = await mutate({
      variables: {
        userId: id,
        isIdVerification: Number(status)
      },
    });

    setStateVariable({ currentPage });
    refetch(variables);

    if (data.DocumentManagement.status === 'success') {
      if (status == 0) {
        showToaster({ messageId: 'docVerify', toasterType: 'success' })
        return;
      }
      let content = {
        name: item.profile.firstName,
        verificationStatus: (status == 1) ? 'approved' : 'rejected'
      }
      sendEmail(decode(item.encryptEmail), 'documentVerification', content);
      showToaster({ messageId: (status == 1) ? 'documentsApproved' : 'documentsRejected', toasterType: 'success' })
    } else {
      showToaster({ messageId: 'commonError', toasterType: 'error' })
    }

  }

  thead = () => {
    const { formatMessage } = this.props.intl;
    return [
      { data: formatMessage(messages.profileID) },
      { data: formatMessage(messages.hostNameLabel) },
      { data: formatMessage(messages.hostEmailLabel) },
      { data: formatMessage(messages.RequestedFiles) },
      { data: formatMessage(messages.actionLabel) }
    ]
  }

  tbody = (props) => {
    const { showAllDocument: { showAllDocument } } = props;
    const { formatMessage } = props.intl;
    const { isRestrict } = this.state;

    return showAllDocument?.results?.map((value, key) => {
      return {
        id: key,
        data: [
          { data: value?.profile?.profileId },
          { data: value?.profile?.firstName },
          { data: !isRestrict ? decode(value.encryptEmail) : censorEmail(decode(value.encryptEmail)) },
          { data: <FileList key={'f' + key} data={value?.document} /> },
          {
            data: <select value={value?.verification?.isIdVerification} onChange={(e) => this.handleUpdate(value?.id, e?.target?.value, value)}>
              <option value={0}>{formatMessage(messages.messageStatus5)}</option>
              <option value={1}>{formatMessage(messages.documentApprove)}</option>
              <option value={2}>{formatMessage(messages.documentReject)}</option>
            </select>
          }
        ]
      }
    })
  }


  render() {
    const { showAllDocument: { showAllDocument, loading }, currentPage, isLoading } = this.props;
    const { formatMessage } = this.props.intl;
    return (
      <div>
        {isLoading && <Loader type={"text"} />}
        {!isLoading &&
          <div><CommonTable
            title={formatMessage(messages.documentverificaiton)}
            thead={this.thead}
            tbody={() => this.tbody(this.props)}
            isSearch
            handleSearch={(e) => this.handleSearchChange(e?.target?.value)}
            loading={loading}
          />
            {
              showAllDocument?.results?.length > 0 && <div>
                <CustomPagination
                  total={showAllDocument.count}
                  currentPage={currentPage}
                  defaultCurrent={1}
                  defaultPageSize={10}
                  change={this.paginationData}
                  paginationLabel={formatMessage(messages.usersLabel)}
                  isScroll
                />
              </div>
            }</div>}
      </div>
    );
  }
}

const mapState = (state) => ({});

const mapDispatch = {
  demoRestrictionEncode
};

export default compose(injectIntl,
  withStyles(s, bt),
  connect(mapState, mapDispatch),
  withMutation(DocumentManagement, { options: { fetchPolicy: 'network-only' } }),
  withQuery(showAllDocumentQuery, {
    name: 'showAllDocument',
    options: (props) => ({
      variables: {
        currentPage: props.currentPage,
        searchList: props.searchList,
      },
      fetchPolicy: 'network-only',
      ssr: false
    })
  })
)(DocumentVerification);